import * as React from 'react'
import {Link} from "gatsby"

const Overlay = () => {
    return (
        <div>

            <div className="pop-up-media">
                <figure>
                    <img alt="" className="ort-img" src={"/images/Regensburg/teaser-regensburg.jpg"}/>
                    <figcaption>
                        Quelle: Stadt Regensburg, Bilddokumentation
                    </figcaption>
                </figure>
            </div>
            <div className="pop-up-body">
                <p className='ort-header'>
                    1594 / 1663–1806: Regensburg – Altes Rathaus </p>
                <p className="ort-subheader">
                    <i>„Ist doch aller Tage rot (Rat) von morgens bis imbiss und von imbiss bis nacht.“ </i>
                </p>
                <Link to="/orte/regensburg/" className='ort-text icon-arrow-right load-infobox'>
                    Mehr erfahren
                </Link>
            </div>

        </div>
    )
}

export default Overlay

